import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(details)/facilities/loading.tsx");
